module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-es-e087445b4874b9969d7cea8fae91d167.svg";